export interface PushApplicationState {
  pushApplications: PartnerApplicationItem[];
  pushApplication?: PartnerApplicationItem;
  pushPlatforms: string[];
  pushOS: PushOS[];
}

export interface PushApplicationItem {
  id?: number | null;
  name: string;
  description?: string | null;
  login?: string | null;
  password?: string | null;
  devices_policy?: string | null;
  check_sign?: boolean | null;
  web: WebPushType;
  fcm: FcmType;
  apns: ApnsType;
  hms: HmsType;
  xiaomi: XiaomiType;
  dp: dpType;
  dp2: dp2Type;
  partner_ids: (number| undefined)[];
  partners: PartnerApplicationItem[];
}

export interface WebPushType {
  public_key: string | null,
  private_key: string | null,
  sender_signature: string | null,
  proxy_settings?: ProxySettings;
}

export interface FcmType {
  protocol?: "XMPP" | "HTTPv1";
  fcm_key?: string | null;
  sender_id?: string | null;
  server_type?: string | null;
  connection_count?: number | null;
  service_account_path?: string | null;
  proxy_settings?: ProxySettings;
}

export interface ApnsType {
  topic?: string | null;
  passphrase?: string | null;
  server_type?: string | null;
  certificate_path?: string | null;
  certificate_type?: string | null;
  key_path?: string | null;
  key_id?: string | null;
  team_id?: string | null;
  proxy_settings?: ProxySettings;
}

export interface HmsType {
  client_id?: string | null;
  client_secret?: string | null;
  proxy_settings?: ProxySettings;
}

export interface XiaomiType {
  app_id?: string | null;
  app_secret?: string | null;
  restricted_package_name?: string | null;
  callback_url?: string | null;
  passthrough?: boolean | null;
  proxy_settings?: ProxySettings;
}

export interface dpType {
  server_ip: string | null;
  server_port: string | null;
  response_timeout: number | null;
  truststore_path: string | null;
  truststore_password: string | null;
}

export interface dp2Type {
  address?: string | null;
  port?: string | null;
  use_ssl?: boolean | null;
  login?: string | null;
  password?: string | null;
  push_status_topic?: string | null;
  proxy_settings?: ProxySettings;
}

export class PushApplicationItemImpl implements PushApplicationItem {
  name: string;
  description: null;
  login: null;
  password: null;
  devices_policy: string;
  check_sign: boolean;
  web: WebPushType;
  fcm: FcmType;
  apns: ApnsType;
  hms: HmsType;
  xiaomi: XiaomiType;
  dp: dpType;
  dp2: dp2Type;
  partner_ids: (number| undefined)[];
  partners: PartnerApplicationItem[];

  constructor() {
    this.name = '';
    this.description =  null;
    this.login= null;
    this.password= null;
    this.devices_policy = 'ALL';
    this.check_sign = false;
    this.web = {
      public_key: null,
      private_key: null,
      sender_signature: null
    };
    this.fcm = {
      protocol: "XMPP",
      fcm_key: null,
      sender_id: null,
      server_type: null,
      connection_count: null
    };
    this.apns = {
      topic: null,
      passphrase: null,
      server_type: null,
      certificate_path: null,
      certificate_type: null,
      key_path: null,
      key_id: null,
      team_id: null
    };
    this.hms = {
      client_id: null,
      client_secret: null
    };
    this.xiaomi = {
      app_id: null,
      app_secret: null,
      passthrough: false
    };
    this.dp = {
      server_ip: null,
      server_port: null,
      response_timeout: null,
      truststore_path: null,
      truststore_password: null
    };
    this.dp2 = {
      address: null,
      port: null,
      use_ssl: false
    }
    this.partners= [];
    this.partner_ids = [];
  }
}

export interface PartnerApplicationItem {
  id: number;
  partner_name: string;
  allowed: boolean;
}

export interface PushApplicationFilterParams {
  name?: string;
  description?: string;
  partner?: string;
}

export interface PushOS {
  os_id: number;
  os: string;
}

export interface ProxySettings {
  id?: number | null;
  host?: string | null;
  port?: string | null;
  login?: string | null;
  password?: string | null;
}
